'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createAutoCorrectedDatePipe = require('./addons/createAutoCorrectedDatePipe');

var _createAutoCorrectedDatePipe2 = _interopRequireDefault(_createAutoCorrectedDatePipe);

var _createNumberMask = require('./addons/createNumberMask');

var _createNumberMask2 = _interopRequireDefault(_createNumberMask);

var _emailMask = require('./addons/emailMask');

var _emailMask2 = _interopRequireDefault(_emailMask);

var _emailPipe = require('./addons/emailPipe');

var _emailPipe2 = _interopRequireDefault(_emailPipe);

var _vanillaTextMask = require('./vanillaTextMask');

var _vanillaTextMask2 = _interopRequireDefault(_vanillaTextMask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  createAutoCorrectedDatePipe: _createAutoCorrectedDatePipe2.default,
  createNumberMask: _createNumberMask2.default,
  emailMask: _emailMask2.default,
  emailPipe: _emailPipe2.default,
  vanillaTextMask: _vanillaTextMask2.default,
  conformToMask: _vanillaTextMask.conformToMask,
  maskInput: _vanillaTextMask.maskInput,
  escapePlaceholderToken: _vanillaTextMask.escapePlaceholderToken,
};
